

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ExpandIcon extends Vue {    

    @Prop({required: true})
    showExpanded!: boolean;     

}

